import React from 'react';
import PropTypes from 'prop-types';
import { AppliedRefinement } from '../Refinements/AppliedRefinement';
import { ClearButton } from './ClearButton';
import { getChipText } from '../../utils/fulfillment-helpers';

export const AppliedFiltersChips = ({
  appliedRefinements,
  desktopSort,
  enableClearAll,
  isMobile,
  onClearAll,
  onDisplay,
  onDisplayChange,
  onFiltersChipChange,
  isPlpSpeedEnabled
}) => {
  if (!appliedRefinements?.length) {
    return null;
  }

  const showClearAllButton = enableClearAll && appliedRefinements.length > 1;

  return (
    <div className="sui-flex sui-flex-nowrap md:sui-flex-wrap sui-gap-2">
      {/* Mobile View: Clear All first */}
      {isMobile && showClearAllButton && (
        <ClearButton onClick={onClearAll} />
      )}
      {appliedRefinements.map((refinement, index) => {
        const {
          dimensionName,
          refinementLabel,
          refinementKey,
          url
        } = refinement;

        const [displayedDimension, displayedRefinement] = getChipText(
          dimensionName, refinementLabel, isPlpSpeedEnabled
        );

        return (
          <AppliedRefinement
            key={`${displayedDimension}-${refinementKey}`}
            index={index}
            deselectUrl={url}
            dimensionName={displayedDimension}
            label={displayedRefinement}
            refinementKey={refinementKey}
            onChange={(refinementLabel === 'On Display') ? onDisplayChange : onFiltersChipChange}
            onDisplay={onDisplay}
            desktopSort={desktopSort}
          />
        );
      })}
      {/* Desktop View: Clear All at last */}
      {!isMobile && showClearAllButton && (
        <ClearButton onClick={onClearAll} />
      )}
    </div>
  );
};

AppliedFiltersChips.propTypes = {
  appliedRefinements: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  desktopSort: PropTypes.string.isRequired,
  enableClearAll: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onClearAll: PropTypes.func.isRequired,
  onDisplay: PropTypes.string,
  onDisplayChange: PropTypes.func,
  onFiltersChipChange: PropTypes.func.isRequired,
  isPlpSpeedEnabled: PropTypes.bool
};

AppliedFiltersChips.defaultProps = {
  onDisplay: 'false',
  onDisplayChange: () => {},
  isPlpSpeedEnabled: false
};